import React, { Component } from 'react';
import styles from './Home.module.css';
import { connect } from 'react-redux';
import { fetchModels, getModels } from '../../modules/models';
import { getMaterials, fetchMaterials } from '../../modules/materials';
import { getScenes, fetchScenes } from '../../modules/scenes';
import {
  fetchProjects,
  getProjects,
  getStatistics,
} from '../../modules/projects';
import Divider from '../../components/Divider';
import PropTypes from 'prop-types';

class Home extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  async componentDidMount() {
    const {
      fetchModels,
      fetchMaterials,
      fetchScenes,
      fetchProjects,
    } = this.props;
    await fetchModels();
    await fetchMaterials();
    await fetchScenes();
    await fetchProjects();
  }

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  openDashboard = project => {
    this.navTo(null, `dashboard?project=${project}`);
  };

  renderProjectOverview = info => {
    return (
      <div key={info.title}>
        <div className={styles.infoTitle}>
          {info.title}
          <span
            className={styles.infoDetails}
            onClick={e => this.openDashboard(info.title)}
          >
            {' '}
            <span className={styles.seprater}>|</span> View details{' '}
          </span>
        </div>
        <div className={styles.infoItems}>
          {info.items.map(item => (
            <div key={item.type} className={styles.infoItem}>
              <div
                className={styles.infoItemValue}
                style={{ color: item.color }}
              >
                {item.value}
              </div>
              <div className={styles.infoItemType}>{item.type}</div>
            </div>
          ))}
        </div>
        <Divider />
      </div>
    );
  };

  renderOrgDetail = (key, value) => (
    <div key={key}>
      <div className={styles.overviewHeader}>
        <div className={styles.tbRowHeader}>{key} </div>
        <div className={styles.tbRowData}>{value.New}</div>
        <div className={styles.tbRowData}> {value['In Work']} </div>
        <div className={styles.tbRowData}>{value['Approved']}</div>
        <div className={styles.tbRowSummary}>
          {value['Total'] || value.New + value['In Work'] + value['Approved']}
        </div>
      </div>
      <Divider />
    </div>
  );

  getOrgStatistics = () => {
    const { statistics } = this.props;
    return statistics;
  };

  getProjectStatistics = () => {
    const { projects } = this.props;
    const formattedData = projects.map(item => ({
      title: item.name,
      items: [
        { type: 'New', value: item.assigned, color: '#000' },
        {
          type: 'In Progress',
          value: item['In Progress'],
          color: '#1F74BF',
        },
        {
          type: 'Ready for Review',
          value: item['Ready for Review'],
          color: '#F5A623',
        },
        {
          type: 'Revisions Required',
          value: item['Revisions Required'],
          color: '#BB0000',
        },
        { type: 'Approved', value: item['Approved'], color: '#1A7B4B' },
      ],
    }));
    return formattedData;
  };

  render() {
    const statistics = this.getOrgStatistics();
    if (!statistics) return null;
    const mydashboard = this.getProjectStatistics();

    return (
      <div className={styles.overview}>
        <div className={styles.header}>Overview</div>
        <div className={styles.overviewHeader}>
          <div style={{ width: '30%' }} />
          <div className={styles.tbHeader}>New </div>
          <div className={styles.tbHeader}>In Work</div>
          <div className={styles.tbHeader}> Complete </div>
          <div className={styles.tbSummaryHeader}>TOTAL</div>
        </div>
        <Divider />
        {Object.keys(statistics).map(k =>
          this.renderOrgDetail(k, statistics[k])
        )}
        <div className={styles.notes}>
          <span className={styles.noteTxt}>
            In work includes status:{' '}
            <i>
              Assigned to vendor, In-progress, Ready for Review, Approved but
              not yet sent, and Revisions Needed
            </i>
          </span>
          <button
            className={styles.reportBtn}
            onClick={e => this.navTo('reports', 'admin')}
          >
            Generate Reports
          </button>
        </div>
        <div className={styles.userReport}>
          <div className={styles.header}> Projects </div>
          <Divider />
          <div className={styles.userDashboard}>
            {mydashboard.map(item => this.renderProjectOverview(item))}
          </div>
          <div />
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    models: getModels(state),
    materials: getMaterials(state),
    scenes: getScenes(state),
    projects: getProjects(state),
    statistics: getStatistics(state),
  }),
  { fetchModels, fetchScenes, fetchMaterials, fetchProjects }
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/index.js